import { render } from "./NoImage.vue?vue&type=template&id=7c9c7caf&scoped=true"
import script from "./NoImage.vue?vue&type=script&lang=js"
export * from "./NoImage.vue?vue&type=script&lang=js"

import "./NoImage.vue?vue&type=style&index=0&id=7c9c7caf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9c7caf"]])

export default __exports__